// eslint-disable-next-line import/no-anonymous-default-export
export default {
   service: [
    {
       id: 1,
       path: "/epilation",
       url: "https://nsm09.casimages.com/img/2021/03/18//21031810380817254117321783.jpg",
       title: 'Epilation',
       text: 'Toutes les zones du corps au détail ou par forfait',
       alt: "outils et accessoires d'épilation",
    },
    {
        id: 2,
        path: "/skinCare",
        url: "https://nsm09.casimages.com/img/2021/03/18//21031810380717254117321781.jpg",
        title: 'Prendre soin de sa peau',
        text: ' Modelage du dos, cuir chevelu, soins des mains et des pieds, maquillage,...',
        alt: "image montrant une jeune femme ayant un soin du visage par une autre personne qui lui applique de la crême sur le visage",
     },
     {
        id: 3,
        path: "/bodyCare",
        url: "https://nsm09.casimages.com/img/2021/03/18//21031810380717254117321782.jpg",
        title: 'Chouchouter son corps',
        text: 'Modelage décontractant, relaxant, tonifiant, fermeté, gommage,...',
        alt: "une femme s'applique de la crême sur sa main gauche",
     },
     {
        id: 4,
        path: "/massage",
        url: "https://nsm09.casimages.com/img/2021/03/18//21031810380817254117321784.jpg",
        title: 'Massage',
        text: 'Massage aux pierres chaudes, sportif, femme enceinte,...',
        alt: "une femme sur le ventre se fait masser le dos",
     }
   ],
   massage: [
      {
        id: 1,
        url: "https://nsm09.casimages.com/img/2021/03/18//21031810380817254117321785.jpg",
        title: "Le massage Femme Enceinte",
        text: "Du côté des futures mamans, le massage prénatal agit sur le développement du corps des femmes pendant la grossesse : il soulage les douleurs et les tensions musculaires ainsi que les crampes dans les jambes.",
        alt: "ventre d'une femme enceinte sur le dos vue de profil avec des chaussons de bébé sur le ventre", 
      },
      {
          id: 2,
          url: "https://nsm09.casimages.com/img/2021/03/18//21031810380817254117321786.jpg",
          title: "Le massage aux pierres chaudes",
          text: "Le massage aux pierres chaudes associe les bienfaits d'un mini-sauna à un massage drainant lymphatique. La chaleur irradie le corps et permet de se relaxer complètement. Les muscles sont rapidement moins douloureux et relâchés, et le bien-être que cela procure est total.",
          alt: "femme allongée sur le ventre avec des pierres sur le dos alignés le long de la colonne vertébrale",  
        },
        {
          id: 3,
          url: "https://nsm09.casimages.com/img/2021/03/18//21031810380917254117321787.jpg",
          title: "Le massage sportif \"Deep Tissue\" ",
          text: "Le massage des tissus profonds est une technique pratiquée généralement avec une certaine intensité afin de relâcher les tensions les plus profondes. Les mouvements sont exécutés très lentement et en profondeur. Ils sont surtout concentrés sur les muscles et les fascias qui les entourent." ,
          alt: "homme allongé sur le ventre se faisant masser l'épaule gauche de manière profonde", 
        },
  ]
}